var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollege(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_13256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89443 3.77539C4.89356 3.77539 4.89259 3.77539 4.89173 3.77539C4.58908 3.77539 4.30442 3.89337 4.08947 4.10778C3.87215 4.32456 3.75244 4.61321 3.75244 4.9205V22.0912C3.75244 22.7209 4.26671 23.2344 4.89895 23.236C7.56434 23.2423 12.0299 23.7979 15.1105 27.0217V9.05207C15.1105 8.83863 15.056 8.63811 14.9531 8.47219C12.4247 4.40031 7.56584 3.78164 4.89443 3.77539Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2467 22.0913V4.9205C28.2467 4.61321 28.127 4.32456 27.9096 4.10778C27.6947 3.89337 27.4098 3.77539 27.1075 3.77539C27.1065 3.77539 27.1055 3.77539 27.1047 3.77539C24.4334 3.78175 19.5745 4.40042 17.046 8.4723C16.9431 8.63822 16.8887 8.83873 16.8887 9.05218V27.0217C19.9693 23.7979 24.4349 23.2423 27.1003 23.236C27.7324 23.2344 28.2467 22.7209 28.2467 22.0913Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 7.73633H30.0266V22.0923C30.0266 23.7 28.7168 25.0109 27.1066 25.0149C24.8458 25.0203 21.1181 25.4623 18.478 27.961C23.044 26.8431 27.8574 27.5698 30.6006 28.195C30.9431 28.273 31.297 28.1924 31.5715 27.9736C31.8449 27.7555 32.0018 27.4293 32.0018 27.0793V8.88122C32.0019 8.24995 31.4882 7.73633 30.8569 7.73633Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97517 22.0923V7.73633H1.14489C0.513726 7.73633 0 8.24995 0 8.88122V27.0789C0 27.4291 0.156876 27.7551 0.430331 27.9733C0.704541 28.1919 1.05816 28.2729 1.40122 28.1946C4.14439 27.5694 8.95788 26.8428 13.5237 27.9607C10.8837 25.4621 7.15596 25.0202 4.89515 25.0148C3.28513 25.0109 1.97517 23.7 1.97517 22.0923Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_13256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.8ba970810bee20807a7bf1ffd9c897ef.svg";
export { ForwardRef as ReactComponent };